import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  width: 100%;\n'], ['\n  display: flex;\n  width: 100%;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  color: #000 !important; /* @todo: until Button supports not faded disabled state */\n  font-weight: bold;\n'], ['\n  color: #000 !important; /* @todo: until Button supports not faded disabled state */\n  font-weight: bold;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  display: flex;\n  padding: 0 10px;\n  text-align: center;\n  align-items: center;\n'], ['\n  display: flex;\n  padding: 0 10px;\n  text-align: center;\n  align-items: center;\n']);

import styled from 'styled-components';
import Button from '@atlaskit/button';

export var Container = styled.div(_templateObject);

export var ButtonActive = styled(Button)(_templateObject2);

export var Ellipsis = styled.span(_templateObject3);